function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "desktop_TravelCard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "assets_TravelCard",
  transform: "translate(-245.000000, -191.000000)",
  fill: "#2E2E2E",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M245.65,191 L257.35,191 C257.708985,191 258,191.307804 258,191.6875 L258,201.3125 C258,201.692196 257.708985,202 257.35,202 L245.65,202 C245.291015,202 245,201.692196 245,201.3125 L245,191.6875 C245,191.307804 245.291015,191 245.65,191 Z M246.3,192.375 L246.3,200.625 L256.7,200.625 L256.7,192.375 L246.3,192.375 Z M247.6,193.75 L251.5,193.75 L251.5,195.125 L247.6,195.125 L247.6,193.75 Z",
  id: "travelcard"
})));

var SvgTravelCard = function SvgTravelCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "11px",
    viewBox: "0 0 13 11",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTravelCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/travel-card.9d3e6b71.svg";
export { ForwardRef as ReactComponent };